<template>
  <div id="app" class="zj-mobile-app">
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import utils from "../../utils";
// eslint-disable-next-line no-unused-vars
import ZJApis from "../../api";

export default {
  name: "ZjApp",
  componentName: "ZjApp",
  data() {
    return {};
  },
  computed: {
    visible() {
      return true;
    }
  },
  created() {}
};
</script>
